module.exports = __webpack_public_path__ + "img/huehnerfleischoben.347d846f.png";